import FAQItem from "../components/questions/Questions"
import styles from "./ForthScreen.module.css"

const ForthScreen = () => {
  return (
    <>
      <div className={styles.header}>שאלות נפוצות</div>
<div className={styles.description}>ריכזתי עבורך את השאלות שבטוח עלו לך לראש עד עכשיו, לחצי על כל שאלה והתשובה תיפתח</div>
<div className={styles.title}>טיפולי יופי</div>
      <FAQItem
        question="מה מיוחד בעיצוב הגבות שלך?"
        answer="אני מעצבת לפי מבנה הפנים והטבעיות של הלקוחה, לא לפי טרנדים. שומרת על מה שמחמיא לה ומדגישה את היופי האמיתי שלה."
      />

      <FAQItem
        question="מה ההבדל בין עיצוב גבות לשיקום גבות?"
        answer="בשיקום גבות אני נותנת לגבה לנשום, מתכננת איתך תהליך שבו היא מתמלאת בהדרגה, מעצבת ומנקה בעדינות עד שמתקבלת תוצאה מלאה ובריאה."
      />

      <FAQItem
        question="אני מפחדת מכאב באיפור קבוע, זה באמת כואב?"
        answer="הטיפול נעשה בעדינות ועם חומרים מרגיעים. התחושה נסבלת לחלוטין והלקוחות מופתעות כמה זה פשוט ונעים."
      />

      <FAQItem
        question="כמה זמן מחזיק האיפור הקבוע?"
        answer="האיפור הקבוע מחזיק לרוב שנה עד שלוש, תלוי בעור ובשגרת הטיפוח שלך. אחרי חודש מגיעים לחיזוק שמקבע את התוצאה הסופית."
      />

      <FAQItem
        question="כמה משתתפות יש בקורס הדבקת הריסים?"
        answer="עד שתי בנות בכיתה, כדי שכל אחת תקבל יחס אישי, תשומת לב ותלמד לעומק את הטכניקה."
      />

  <div className={styles.title}>תכשיטים</div>
    <FAQItem
        question="איזה סוגי תכשיטים יש אצלך?"
        answer="אני מציעה תכשיטים מינימליסטיים בעיצוב נקי ואלגנטי, שמתאימים לכל סגנון. טבעות, שרשראות, עגילים וצמידים שעשויים מכסף 925."
      />


  

      <FAQItem
        question="איך מבצעים הזמנה?"
        answer="מגיעים לחנות פיזית (נמצאת בבאר יעקב) או שפשוט שולחים לי הודעה עם התכשיט שמצא חן בעינייך, ואני אשלח לך את כל הפרטים, כולל זמינות ומחיר."
      />

      <FAQItem
        question="האם התכשיטים מתאימים גם כמתנה?"
        answer="בהחלט. כל תכשיט נארז בקופסה יוקרתית עם שקית ממותגת, מושלם למתנה לעצמך או למישהי שאת אוהבת."
      />



   
    </>
  )
}

export default ForthScreen
